export default __webpack_public_path__ + "static/media/logo-meetpharma-white.1c8d5689.png";